import { Component } from '@angular/core';
import { FoodsProvider } from '../../../providers/foods/foods';
import {AlertController} from "ionic-angular";
import * as firebase from "firebase";

/**
 * Generated class for the MenuFoodsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-menu-foods',
  templateUrl: 'menu-foods.html',
})
export class MenuFoodsPage {

  constructor(
    public foodServ: FoodsProvider,
    public alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MenuFoodsPage');
  }


  supplies(){
    this.foodServ.supplies();
  }

  weekSupplies(){
    console.log(this.foodServ.weeks)
    const prompt = this.alertCtrl.create({
      title: 'Seleccione semana',
      inputs: [],
      buttons: [
        {
          text: 'Cancelar',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Seleccionar',
          handler: data => {
            this.foodServ.weekSupplies(data);
          }
        }
      ]
    });
    this.foodServ.weeks.forEach((x) => {
      prompt.addInput({
        type: 'radio',
        label: 'Semana Nº'+ x.week,
        value: x.weekCode
      })
    })

    prompt.present();

  }

  counters(){
      this.foodServ.counters();
  }

  report(){
      this.foodServ.report();
  }
}



// WEBPACK FOOTER //
// ./src/pages/days/menu-foods/menu-foods.ts